export default "__VITE_ASSET__NM6osrTP__"